import { IndustryDistributionItem } from './dashboardApi';

export interface IndustriesDataset {
  labels: string[];
  values: number[];
}

export const buildIndustriesDataset = (
  industries: IndustryDistributionItem[]
): IndustriesDataset => {
  if (!industries?.length) {
    return { labels: [], values: [] };
  }

  return {
    labels: industries.map((industry) => industry.name || 'Unknown'),
    values: industries.map((industry) => industry.message_count ?? 0),
  };
};

